export default function mapRelationships(state, relationships) {
  if (relationships == null || !Array.isArray(relationships) || relationships.length == 0) return []
  return relationships
    .map((relationship) => state.objects?.[relationship?.type]?.[relationship?.id])
    .filter((object) => object)
}
